// extracted by mini-css-extract-plugin
export default {"physical":"styles_physical__2aytL"};